@import "src/styles/common/_colors.scss";

.alarmsAndEventsWrapper {
    // display: flex;
    // flex: 1 1;
    // flex-direction: column;   
    height: 100%;
}
